export default "/assets/images/vendor/leaflet-extra-markers/dist/markers_default.png?c832adf43b69321540d3a99fa0a2a4b2";